import React from "react";
import { StyleVariant, TextWithSubtextContentDefinition } from '../AmorgMenuTypes';
import styled from "styled-components";
import { colorHelper } from "../helpers/colorHelper";

type TextWithSubtextContentProps = TextWithSubtextContentDefinition &
{
    flex:string,
    isHovering:boolean
    styleVariant:StyleVariant,
    subtextStylevariant:StyleVariant,
}
export function TextWithSubtextContent(props:TextWithSubtextContentProps):JSX.Element
{
    return (
        <div style={{display:'flex', flexDirection:'column', flex:props.flex}}>
            <StyledLabel
                styleVariant={props.styleVariant}
                isHovering={props.isHovering}>
                {props.text}
            </StyledLabel>
            <StyledSubLabel
                styleVariant={props.subtextStylevariant}
                isHovering={props.isHovering}>
                {props.subtext}
            </StyledSubLabel>
        </div>
    );
}

const StyledLabel = styled.label<{isHovering:boolean,styleVariant:StyleVariant}>`
    text-align:left;
    color:${props => colorHelper.getForegroundColor(props.styleVariant)};
    cursor:${props => props.isHovering ? 'pointer' : 'default'};
    text-decoration:${props => props.styleVariant === 'strike-through' ? 'line-through' : 'none' };
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 22px;
`;

const StyledSubLabel = styled.label<{isHovering:boolean,styleVariant:StyleVariant}>`
    text-align:left;
    color:${props => colorHelper.getForegroundColor(props.styleVariant)};
    cursor:${props => props.isHovering ? 'pointer' : 'default'};
    text-decoration:${props => props.styleVariant === 'strike-through' ? 'line-through' : 'none' };
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 22px;
`;